export default defineNuxtRouteMiddleware((to, from) => {
  useFullscreenLoading().stop()
})
